import { defineMessages } from 'react-intl';


const GIC_TYPES = {
    NONREGISTERED: 'non-registered',
    REGISTERED: 'registered',
    TFSA: 'tfsa',
    USD: 'usd',
};

const MESSAGES = defineMessages({
    [GIC_TYPES.NONREGISTERED]: {
        id: 'gics.account-type.non-registered',
        defaultMessage: 'Non-registered',
    },
    [GIC_TYPES.REGISTERED]: {
        id: 'gics.account-type.registered',
        defaultMessage: 'Registered',
    },
    [GIC_TYPES.TFSA]: {
        id: 'gics.account-type.tfsa',
        defaultMessage: 'TFSA',
    },
    [GIC_TYPES.USD]: {
        id: 'gics.account-type.usd',
        defaultMessage: 'USD',
    },
});

const GIC_TYPES_OPTIONS = Object.values(GIC_TYPES).map(value => ({
    value: value,
    label: MESSAGES[value],
}));


export { GIC_TYPES };
export default GIC_TYPES_OPTIONS;
